import { render, staticRenderFns } from "./LoyaltyByLocation.vue?vue&type=template&id=c71b29e2&scoped=true&"
import script from "./LoyaltyByLocation.vue?vue&type=script&lang=js&"
export * from "./LoyaltyByLocation.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyByLocation.vue?vue&type=style&index=0&id=c71b29e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71b29e2",
  null
  
)

export default component.exports